module.exports = __webpack_public_path__ + "img/qr_icon.c0011540.svg";